export enum LoginType {
  email = 'email',
  phone = 'phone',
}

export enum SignInType {
  OTP = 'otp',
  PASSWORD = 'password',
}

export enum PasswordStrength {
  VeryWeak = 0,
  Weak = 1,
  Moderate = 2,
  Strong = 3,
  VeryStrong = 4,
}

export enum PasswordType {
  profile = 'profile',
  forgotPassword = 'forget-password',
  login = 'login',
}

// Password strength label
export const strengthMap: Record<PasswordStrength, string> = {
  [PasswordStrength.VeryWeak]: 'Very Weak',
  [PasswordStrength.Weak]: 'Weak',
  [PasswordStrength.Moderate]: 'Moderate',
  [PasswordStrength.Strong]: 'Strong',
  [PasswordStrength.VeryStrong]: 'Very Strong',
};
